import { Passenger } from '@ibe.models/passenger.model.lib';
import { getBrandFeatures } from '@ibe/models/ui';
import { AncillaryListItem } from './ancillary-list-item';
var BookedTrip = /** @class */ (function () {
    function BookedTrip(flights, pnr, booking_type, status, passengers, passengers_info, payment, contact_details, is_time_to_think, isCorporate, time_to_think, stopover, travel_agency, added_to_account, loyalty_program, is_group) {
        this.flights = flights;
        this.passengers = passengers ? passengers : [];
        this._passengers_info = passengers_info ? passengers_info : [];
        this.pnr = pnr;
        this.booking_type = booking_type;
        this.status = status ? status : 'unfinished';
        this.payment = payment ? payment : [];
        this.contact_details = contact_details ? contact_details : [];
        this.is_time_to_think = is_time_to_think ? is_time_to_think : false;
        this.isCorporate = isCorporate ? isCorporate : false;
        this.time_to_think = time_to_think;
        this.stopover = stopover ? stopover : false;
        this.travel_agency = travel_agency ? travel_agency : false;
        this.added_to_account = added_to_account !== undefined ? added_to_account : false;
        this.loyalty_program = loyalty_program;
        this.is_group = is_group !== undefined ? is_group : false;
        this.carbon_offset = false;
        this.danish_guarantee_fund = false;
        this.insurance = null;
    }
    Object.defineProperty(BookedTrip.prototype, "segmentedPassengerCount", {
        /**
         * Returns the number of passengers per age segment on this booked trip
         * @returns {PassengersSegmentedCount} a dictionary of each segment and the corresponding count
         */
        get: function () {
            var dictionary = {
                adults: 0,
                youngAdults: 0,
                children: 0,
                infants: 0
            };
            this._passengers_info.forEach(function (passenger) {
                switch (passenger.type) {
                    case 'adult':
                        dictionary.adults++;
                        break;
                    case 'youngAdult':
                        dictionary.youngAdults++;
                        break;
                    case 'child':
                        dictionary.children++;
                        break;
                    case 'infant':
                        dictionary.infants++;
                }
            });
            return dictionary;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BookedTrip.prototype, "passengers_info", {
        get: function () {
            return this._passengers_info;
        },
        set: function (data) {
            this._passengers_info = data;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BookedTrip.prototype, "passengerCount", {
        /** Returns the total number of passengers for this booked trip */
        get: function () {
            return this._passengers_info.length;
        },
        enumerable: true,
        configurable: true
    });
    /** Removes all passengers from this booked trip */
    BookedTrip.prototype.emptyPassengers = function () {
        this._passengers_info = [];
    };
    /** Removes all flights from this booked trip */
    BookedTrip.prototype.emptyFlights = function () {
        this.flights = [];
        this.time_to_think = null;
    };
    /**
     * Adds a new passenger of a given age type to this booking.
     * It will automatically make the first adult added the primary passenger.
     * @param type {PassengerAgeSegment} the age segment that this passenger fits into
     */
    BookedTrip.prototype.addPassenger = function (type) {
        var p = new Passenger(type);
        this._passengers_info.push(p);
        if (type === 'adult') {
            p.typeCount = this.segmentedPassengerCount.adults;
        }
        else if (type === 'youngAdult') {
            p.typeCount = this.segmentedPassengerCount.youngAdults;
        }
        else if (type === 'child') {
            p.typeCount = this.segmentedPassengerCount.children;
        }
        else if (type === 'infant') {
            p.typeCount = this.segmentedPassengerCount.infants;
        }
        if (this.segmentedPassengerCount.adults === 1) {
            p.primary = true;
        }
        p.id = (this.segmentedPassengerCount.adults + this.segmentedPassengerCount.youngAdults + this.segmentedPassengerCount.children + this.segmentedPassengerCount.infants).toString();
        this.flights.forEach(function (flight) {
            flight.assignPassenger(p);
        });
    };
    BookedTrip.prototype.addPassengerModel = function (p) {
        this._passengers_info.push(p);
    };
    BookedTrip.prototype.addFlight = function (p) {
        this.flights.push(p);
    };
    BookedTrip.prototype.setType = function (type) {
        if (type === void 0) { type = 'R'; }
        this.booking_type = type;
    };
    BookedTrip.prototype.setStopover = function (type) {
        if (type === void 0) { type = false; }
        this.stopover = type;
    };
    BookedTrip.prototype.addPassengerDetails = function (randomPassenger, index) {
        // Mock passenger data
        this._passengers_info[index].id = randomPassenger.id;
        this._passengers_info[index].firstName = randomPassenger.firstName;
        this._passengers_info[index].lastName = randomPassenger.lastName;
        this._passengers_info[index].date_of_birth = randomPassenger.date_of_birth;
        this._passengers_info[index].gender = randomPassenger.gender;
        this._passengers_info[index].ticket_number = randomPassenger.ticket_number;
        this._passengers_info[index].frequentFlyer = randomPassenger.frequentFlyer;
        this._passengers_info[index].emergencyContact = randomPassenger.emergencyContact;
        this._passengers_info[index].personalDocuments = randomPassenger.personalDocuments;
        this._passengers_info[index].contacts = randomPassenger.contacts;
        this._passengers_info[index].work_travel = randomPassenger.work_travel;
        this._passengers_info[index].ancillaries_limitations = randomPassenger.ancillaries_limitations;
    };
    /**
     * Returns the flight object that matches the given id.
     * If none is found, null is returned instead
     * @param id {string} the identifier of the flight to find
     */
    BookedTrip.prototype.getFlight = function (id) {
        var result = this.flights.filter(function (flight) { return flight.id === id; });
        return result.length > 0 ? result[0] : null;
    };
    /**
     * Returns the date of the last flight
     */
    BookedTrip.prototype.getFlightsLatestDate = function () {
        return this.flights[this.flights.length - 1].departure.time;
    };
    BookedTrip.prototype.buildAncillaryListToPay = function () {
        var ancillaries = [];
        var ancillariesMap = new Map();
        ancillariesMap.set('seats', new Map());
        ancillariesMap.set('bags', new Map());
        ancillariesMap.set('fasttrack', new Map());
        ancillariesMap.set('lounge', new Map());
        ancillariesMap.set('sports', new Map());
        ancillariesMap.set('music', new Map());
        ancillariesMap.set('pets', new Map());
        ancillariesMap.set('meals', new Map());
        ancillariesMap.set('prefboard', new Map());
        // ancillariesMap.set('insurance', new Map<Flight, Ancillaries[]>());
        this.flights.forEach(function (flight) {
            flight.passengerInfo.forEach(function (passenger) {
                passenger.stops.forEach(function (infoStop) {
                    if (infoStop.boughtSeat) {
                        var map = ancillariesMap.get('seats'), collection = map.get(flight);
                        if (collection) {
                            collection.push(infoStop);
                        }
                        else {
                            map.set(flight, [infoStop]);
                        }
                    }
                    if (infoStop.specialMeals) {
                        var map = ancillariesMap.get('meals'), collection = map.get(flight);
                        if (collection) {
                            collection.push(infoStop);
                        }
                        else {
                            map.set(flight, [infoStop]);
                        }
                    }
                });
                /**
                * Get the first stop and duplicate it for other flights
                */
                var info = passenger.stops[0];
                if (info.added_bags && info.added_bags.length) {
                    var map = ancillariesMap.get('bags'), collection = map.get(flight);
                    if (collection) {
                        collection.push(info);
                    }
                    else {
                        map.set(flight, [info]);
                    }
                }
                if (info.fastTrackEnabled) {
                    var map = ancillariesMap.get('fasttrack'), collection = map.get(flight);
                    if (collection) {
                        collection.push(info);
                    }
                    else {
                        map.set(flight, [info]);
                    }
                }
                if (info.loungeEnabled) {
                    var map = ancillariesMap.get('lounge'), collection = map.get(flight);
                    if (collection) {
                        collection.push(info);
                    }
                    else {
                        map.set(flight, [info]);
                    }
                }
                if (info.sportsEquipment && info.sportsEquipment.length) {
                    var map = ancillariesMap.get('sports'), collection = map.get(flight);
                    if (collection) {
                        collection.push(info);
                    }
                    else {
                        map.set(flight, [info]);
                    }
                }
                if (info.musicInstruments && info.musicInstruments.length) {
                    var map = ancillariesMap.get('music'), collection = map.get(flight);
                    if (collection) {
                        collection.push(info);
                    }
                    else {
                        map.set(flight, [info]);
                    }
                }
                if (info.pets && info.pets.length) {
                    var map = ancillariesMap.get('pets'), collection = map.get(flight);
                    if (collection) {
                        collection.push(info);
                    }
                    else {
                        map.set(flight, [info]);
                    }
                }
                if (info.preferredBoardingEnabled) {
                    var map = ancillariesMap.get('prefboard'), collection = map.get(flight);
                    if (collection) {
                        collection.push(info);
                    }
                    else {
                        map.set(flight, [info]);
                    }
                }
            });
        });
        var keys = ['seats', 'bags', 'fasttrack', 'lounge', 'sports', 'music', 'pets', 'meals', 'prefboard'];
        var tmpMap, anx;
        keys.forEach(function (key) {
            tmpMap = ancillariesMap.get(key);
            tmpMap.forEach(function (info, flight) {
                var brand = getBrandFeatures(flight.options.brand);
                switch (key) {
                    case 'seats':
                        anx = { quantity: 0, cost: 0 };
                        info.forEach(function (i) {
                            anx.quantity += 1;
                            anx.cost += i.boughtSeat.price;
                        });
                        ancillaries.push(new AncillaryListItem('Seats', 'plane_related--seat', flight, anx.quantity, anx.cost, 'seatmap', 'seats'));
                        break;
                    case 'bags':
                        anx = { quantity: 0, cost: 0 };
                        info.forEach(function (i) {
                            anx.quantity += i.added_bags.length;
                            anx.cost += i.added_bags.reduce(function (acc, val) { return acc + val; }, 0) * flight.stops_labels.length;
                        });
                        ancillaries.push(new AncillaryListItem('Extra Bags', 'ancillaries--luggage', flight, anx.quantity, anx.cost, 'checked-bags', 'bags'));
                        break;
                    case 'fasttrack':
                        var fastTrackEnabledPrice = brand.filter(function (cur) { return cur.type == 'extra'; }).find(function (cur) { return cur.id == 'fasttrack'; }).price * flight.stops_labels.length || 0;
                        ancillaries.push(new AncillaryListItem('Fast Track', 'plane_related--fast_track', flight, info.length, (info.length * fastTrackEnabledPrice), 'fast-track', 'fasttrack'));
                        break;
                    case 'lounge':
                        var loungeEnabledPrice = brand.filter(function (cur) { return cur.type == 'extra'; }).find(function (cur) { return cur.id == 'lounge'; }).price * flight.stops_labels.length || 0;
                        ancillaries.push(new AncillaryListItem('Lounge', 'ancillaries--lounge', flight, info.length, (info.length * loungeEnabledPrice), 'ancillaries--lounge', 'lounge'));
                        break;
                    case 'sports':
                        anx = { quantity: 0, cost: 0 };
                        info.forEach(function (i) {
                            anx.quantity += i.sportsEquipment.length;
                            anx.cost += i.sportsEquipment.reduce(function (acc, val) { return acc + val.price; }, 0) * flight.stops_labels.length;
                        });
                        ancillaries.push(new AncillaryListItem('Sport Equipments', 'ancillaries--sports_equipment', flight, anx.quantity, anx.cost, 'ancillaries--sports_equipment', 'sports'));
                        break;
                    case 'music':
                        anx = { quantity: 0, cost: 0 };
                        info.forEach(function (i) {
                            anx.quantity += i.musicInstruments.length;
                            anx.cost += i.musicInstruments.reduce(function (acc, val) { return acc + val.price; }, 0) * flight.stops_labels.length;
                        });
                        ancillaries.push(new AncillaryListItem('Music Instruments', 'leisure_and_commodities--music', flight, anx.quantity, anx.cost, 'ancillaries--music-instruments', 'music'));
                        break;
                    case 'pets':
                        anx = { quantity: 0, cost: 0 };
                        info.forEach(function (i) {
                            anx.quantity += i.pets.length;
                            anx.cost += i.pets.reduce(function (acc, val) { return acc + val.price; }, 0) * flight.stops_labels.length;
                        });
                        ancillaries.push(new AncillaryListItem('Pets', 'luggage--small_pets', flight, anx.quantity, anx.cost, 'ancillaries--small-pets', 'pets'));
                        break;
                    case 'meals':
                        anx = { quantity: 0, cost: 0 };
                        info.forEach(function (i) {
                            anx.quantity += 1;
                            anx.cost += i.specialMeals.price * flight.stops_labels.length;
                        });
                        ancillaries.push(new AncillaryListItem('Special Meals', 'ancillaries--special_meals', flight, anx.quantity, anx.cost, 'ancillaries--special-meals', 'meals'));
                        break;
                    case 'prefboard':
                        var prefBoardEnabledPrice = brand.filter(function (cur) { return cur.type == 'extra'; }).find(function (cur) { return cur.id == 'prefboard'; }).price * flight.stops_labels.length || 0;
                        ancillaries.push(new AncillaryListItem('Preferred Boarding', 'plane_related--preferred-board', flight, info.length, (info.length * prefBoardEnabledPrice), 'pref-board', 'prefboard'));
                        break;
                }
            });
        });
        /**
         * Insurance
         */
        // const insurance = this.insurance;
        // if (insurance) {
        // 	ancillaries.push(new AncillaryListItem('Insurance', 'travel-insurance', null, this.passengerCount, this.passengerCount * insurance.reduce((acc, cur) => acc += cur.price, 0), 'travel-insurance'));
        // }
        var response_ancillaries = ancillaries.map(function (cur) {
            cur.cost = parseFloat(cur.cost).toFixed(2);
            return cur;
        });
        return response_ancillaries;
    };
    BookedTrip.prototype.resetExtras = function () {
        this.flights.map(function (flight) { return flight.resetExtras(); });
    };
    BookedTrip.prototype.groupAncillaries = function () {
        var arr = this.buildAncillaryListToPay();
        var group = [];
        var keys = ['Seats', 'Extra Bags', 'Fast Track', 'Lounge', 'Sport Equipments', 'Music Instruments', 'Pets', 'Special Meals'];
        keys.forEach(function (key) {
            var results = arr.filter(function (value) { return value.name === key; });
            if (results.length > 0) {
                group.push(Object.assign({}, { name: key, count: results.reduce(function (total, elem) { return total + elem.quantity; }, 0), discount: results.reduce(function (total, elem) { return total + parseInt(elem.cost, 10); }, 0), active: false, id: results[0].id, total: 0 }));
            }
        });
        return group;
    };
    return BookedTrip;
}());
export { BookedTrip };
